export class OrderedTaskStepEval {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get step() {
        return this.parent;
    }
    get task() {
        return this.step.task;
    }
    get state() {
        return this.step.stepState;
    }
    get attemptsNumber() {
        return this.step.selectionEvents.length;
    }
    get isSelectionPending() {
        return !this.state.latestSelectedOption;
    }
    get hasUserSelectedAny() {
        return !!this.state.latestSelectedOption;
    }
    get isNowCorrectlySelected() {
        return this.hasUserSelectedAny && this.step.correctOption === this.state.latestSelectedOption;
    }
    get wasCorrectlySelectedOnFirstAttempt() {
        return this.hasUserSelectedAny && this.step.correctOption === this.state.latestSelectedOption;
    }
    get isWronglySelected() {
        return this.hasUserSelectedAny && this.step.correctOption !== this.state.latestSelectedOption;
    }
    get isFailed() {
        return !this.isNowCorrectlySelected && this.attemptsNumber >= this.task.numberOfTries;
    }
    get reachedPoints() {
        if (this.attemptsNumber === 0)
            return 0;
        if (this.isNowCorrectlySelected && this.attemptsNumber === 1)
            return 1;
        if (this.isNowCorrectlySelected && this.attemptsNumber === 2)
            return 0.3;
        if (this.isNowCorrectlySelected && this.attemptsNumber === 3)
            return 0.1;
        return 0;
    }
    get legacyEvalText() {
        return this.step.stepState.selectedOptionIndicies.join(',');
    }
}
